<template>
  <van-tabbar
    :value="activeRoute"
    fixed
    placeholder
    active-color="#1989fa"
    inactive-color="#666666"
    @change="handleTabChange"
  >
    <van-tabbar-item name="ykyCodeIndex" icon="goods-collect-o">商品信息</van-tabbar-item>
    <van-tabbar-item name="inspectionReport" icon="records-o">检测报告</van-tabbar-item>
    <van-tabbar-item name="activity" icon="shopping-cart-o">积分商城</van-tabbar-item>
    <van-tabbar-item name="userFeedback" icon="user-o">用户反馈</van-tabbar-item>
  </van-tabbar>
</template>

<script>

export default {
  name: 'Tabbar',
  computed: {
    activeRoute() {
      const path = this.$route.path
      if (path === '/ykyCodeIndex') return 'ykyCodeIndex'
      if (path === '/inspectionReport') return 'inspectionReport'
      if (path === '/activity') return 'activity'
      if (path === '/userFeedback') return 'userFeedback'
      return 'ykyCodeIndex'
    }
  },
  methods: {
    handleTabChange(name) {
      const routeMap = {
        ykyCodeIndex: '/ykyCodeIndex',
        inspectionReport: '/inspectionReport',
        activity: '/activity',
        userFeedback: '/userFeedback'
      }
      this.$router.replace(routeMap[name])
    }
  }
}
</script>

<style scoped>
:deep(.van-tabbar) {
  background: #fff;
}
</style>